import { useRef } from 'react';
import {
  Box,
  Table,
  Pagination,
  TextInput,
  Button,
  MediaQuery,
  Modal,
  Stack,
  Grid,
  Col,
  Radio,
  Text,
  Divider,
  Select,
  Group,
  Checkbox
} from '@mantine/core';
import { BiDollar } from 'react-icons/bi';
import { useForm } from '@mantine/form';
import dayjs from 'dayjs';

import { useStyles } from './style';
import edit from '../../../assets/icons/edit.svg';
import view from '../../../assets/icons/view.svg';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SearchIcon } from '../../../assets/icons/search';
import { data, statusClass, propertiesUserType } from './properties';
import { baseURL } from '../../../config/urls';
import {
  getHeader,
  doRedirectIfUnAuth,
  getUserType
} from '../../../config/userSession';
import plusIcon from '../../../assets/icons/plus-icon.svg';
import { IconCheck, IconX } from '@tabler/icons-react';
import { notifications } from '@mantine/notifications';
import { noRecordFound } from '../../../utils/const';
import { useLocation } from 'react-router-dom';
import handleSearch from '../Search';

function PropertyManagementList() {
  const userType = getUserType();
  const [viewAddManager, setViewAddManager] = useState(false);
  const [oldProperty, setOldproperty] = useState('');
  const [editManager, setEditManager] = useState(false);
  const [sending, setSending] = useState(false);
  const { classes, theme } = useStyles(useStyles);
  const [activePage, setActivePage] = useState(1);
  const navigate = useNavigate();
  const [entries, setEntries] = useState([]);
  const [properties, setProperties] = useState([]);
  const [pageLoadEntries, setPageLoadEntries] = useState([]);
  const [totalPage, setTotalPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const cacheListing = useRef({});
  const params = new URLSearchParams();
  const [hasManagerEmail, setHasManagerEmail] = useState(false);

  const mangerform = useForm({
    initialValues: {
      propertyManagerName: '',
      propertyManagerEmail: '',
      propertyManagerAccess: null,
      propertyId: ''
    },
    validate: {
      propertyManagerName: (val) => (val.length < 2 ? 'Name too short' : null),
      propertyManagerEmail: (val) =>
        /^\S+@\S+$/.test(val) ? null : 'Invalid email address'
    }
  });
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get('email');

  params.append('page', activePage);
  params.append('pSize', pageSize);
  params.append('email', email);

  const pageChangeHandler = (page) => {
    setActivePage(page);
  };

  const fetchContactForm = async () => {
    if (params in cacheListing) {
      setEntries(cacheListing[params]);
      setPageLoadEntries(cacheListing[params]);
      return;
    }
    const response = await fetch(
      `${baseURL}/property/property-managers-list?` + params.toString(),
      {
        method: 'GET',
        headers: getHeader()
      }
    );
    if (response.ok) {
      let contactFormListing = await response.json();
      setEntries(contactFormListing.data);
      setPageLoadEntries(contactFormListing.data);
      setTotalPage((contactFormListing.totalCount + pageSize - 1) / pageSize);
      cacheListing[params] = contactFormListing.data;
    } else {
      doRedirectIfUnAuth(response.status);
    }
  };
  const fetchAllProperties = async () => {
    if (params in cacheListing) {
      setProperties(cacheListing[params]);
      setPageLoadEntries(cacheListing[params]);
      return;
    }
    const response = await fetch(
      `${baseURL}/property/list?` + params.toString(),
      {
        method: 'GET',
        headers: getHeader()
      }
    );
    if (response.ok) {
      let contactFormListing = await response.json();
      setProperties(contactFormListing.data);
      setPageLoadEntries(contactFormListing.data);
      setTotalPage((contactFormListing.totalCount + pageSize - 1) / pageSize);
      cacheListing[params] = contactFormListing.data;
    } else {
      doRedirectIfUnAuth(response.status);
    }
  };
  useEffect(() => {
    fetchContactForm();
    fetchAllProperties();
  }, [activePage]);

  const handleAddManager = async () => {
    if (!mangerform.isValid()) return;
    const propertyId = mangerform.getInputProps('propertyId').value;
    setSending(true);
    const body = {
      ...mangerform.values,
      propertyId
    };

    if (oldProperty && oldProperty !== propertyId) {
      body.oldProperty = oldProperty;
    }
    // if (hasManagerEmail && !editManager) {
    //   setSending(false);

    //   return showNotification(
    //     'failuse',
    //     '',
    //     'Manager already exists for this property',
    //     '550px'
    //   );
    // }
    const response = await fetch(`${baseURL}/property/manager/${propertyId}`, {
      method: 'PUT',
      headers: getHeader(),
      body: JSON.stringify(body)
    });
    if (response.status === 201) {
      showNotification(
        'success',
        '',
        `Property manager ${editManager ? 'updated' : 'added'} successfully`,
        '450px'
      );
      setViewAddManager(false);
      setTimeout(() => {
        navigate(0);
      }, 1000);
    }
    setSending(false);
  };

  useEffect(() => {
    if (!viewAddManager) {
      mangerform.setValues({
        propertyManagerName: '',
        propertyManagerEmail: '',
        propertyManagerAccess: null,
        propertyId: ''
      });
    }
  }, [viewAddManager]);
  const formatAccessLabel = (value) => {
    switch (value) {
      case 'service-request':
        return 'Service Request';
      case 'invoice':
        return 'Invoice';
      case 'edit-profile':
        return 'Can Edit Profile';
      case 'rent-payment':
        return 'Rent Payment';
      default:
        return value;
    }
  };
  const rows = entries.map((element, index) => {
    const accessPermissions = element?.access;
    return (
      <tr
        className={index % 2 === 0 ? classes.tableRowWhite : classes.tableRow}
        key={`${element.propertName}${index}`}
      >
        <td className={classes.tableData}>{element.propertName}</td>
        <td className={classes.tableData}>{element.name}</td>
        <td className={classes.tableData}>{element.email}</td>

        <td className={classes.tableData}>
          {Array.isArray(accessPermissions)
            ? accessPermissions
                .map((access) => formatAccessLabel(access))
                .join(', ')
            : ''}
        </td>
        <td className={classes.tableData}>
          <p
            className={`${classes.status} ${
              element.status === 'pending'
                ? classes.pending
                : element.status === 'accepted'
                ? classes.accepted
                : element.status === 'expired'
                ? classes.accepted
                : element.status === 'cancelled' ||
                  (element.ExpirationDate &&
                    new Date(element.ExpirationDate) < new Date())
                ? classes.expired
                : ''
            }`}
          >
            {element.ExpirationDate &&
            new Date(element.ExpirationDate) < new Date() &&
            element.status !== 'accepted' &&
            element.status !== 'cancelled'
              ? 'expired'
              : element.status}
          </p>
        </td>
        <td className={classes.tableData}>
          <Box className={classes.editAndView}>
            <p
              onClick={() => {
                setViewAddManager(true);
                setEditManager(true);
                mangerform.setFieldValue('propertyId', element.propertyId);
                mangerform.setFieldValue(
                  'propertyManagerAccess',
                  element.access
                );
                mangerform.setFieldValue('propertyManagerName', element.name);
                mangerform.setFieldValue('propertyManagerEmail', element.email);
                setOldproperty(element.propertyId);
              }}
              style={{ cursor: 'pointer' }}
            >
              <img
                className={classes.action}
                src={userType === propertiesUserType.tenant ? view : edit}
                alt="edit"
              />
            </p>
          </Box>
        </td>
      </tr>
    );
  });

  const showNotification = (notificationType, message, title, width) => {
    let colorCode = notificationType === 'success' ? 'secondary.0' : 'red';

    notifications.show({
      id: 'lanlord-property-management-notification',
      withCloseButton: true,
      title: title,
      message: message,
      autoClose: false,
      color: colorCode,
      icon:
        notificationType === 'success' ? (
          <IconCheck size="2.5rem" />
        ) : (
          <IconX size="2.5rem" />
        ),
      style: {
        backgroundColor: theme.colors.background[0],
        padding: '12px 12px',
        fontSize: '8rem',
        lineHeight: '1.2',
        minHeight: '120px',
        width: width, // 👈 Set desired width here
        maxWidth: '90%' // Optional: responsive on smaller screens
      },
      styles: {
        title: {
          fontSize: '1.5rem',
          lineHeight: 1.3
        },
        description: {
          fontSize: '1.2rem',
          lineHeight: 1.4
        },
        closeButton: {
          color: 'white',
          backgroundColor: 'black',
          '&:hover': {
            backgroundColor: 'gray', // Change to your preferred hover color
            color: 'yellow' // Example hover text color
          }
        }
      }
    });
  };
  const propertyOptions = properties.map((prop) => ({
    value: prop.propertyId,
    label: prop.propertName
  }));

  const selectedPropertyId = mangerform.values.propertyId;

  let filteredProperties = properties.filter(
    (prop) => prop.propertyManagerEmail === null
  );

  const selectedProperty = properties.find(
    (prop) => prop.propertyId === selectedPropertyId
  );

  if (
    selectedProperty &&
    selectedProperty.propertyManagerEmail !== null &&
    !filteredProperties.find((prop) => prop.propertyId === selectedPropertyId)
  ) {
    filteredProperties.push(selectedProperty);
  }

  const updatepropertyOptions = filteredProperties.map((prop) => ({
    value: prop.propertyId,
    label: prop.propertName
  }));

  useEffect(() => {
    const selectedProperty = properties.find(
      (prop) => prop.propertyId === mangerform.values.propertyId
    );

    if (selectedProperty?.propertyManagerEmail) {
      setHasManagerEmail(true);
    } else {
      setHasManagerEmail(false);
    }
  }, [mangerform.values.propertyId, properties]);

  useEffect(() => {
    if (!viewAddManager) {
      setEditManager(false);
    }
  }, [viewAddManager]);
  return (
    <>
      {' '}
      <Box className={classes.wrapper}>
        <Box className={classes.headerAndSearch}>
          <p className={classes.title}>{data.titles.propertyList}</p>
          <Box className={classes.searchAndFilter}>
            <TextInput
              icon={<SearchIcon />}
              onChange={(e) =>
                handleSearch(e, pageLoadEntries, setEntries, [
                  'name',
                  'email',
                  'propertName',
                  'access'
                ])
              }
              radius={'xl'}
              className={classes.searchInput}
              placeholder={data.titles.search}
            />
            {userType === propertiesUserType.landlord ? (
              <MediaQuery
                query="(max-width: 500px)"
                styles={{ display: 'none' }}
              >
                <Button
                  onClick={() => setViewAddManager(true)}
                  color="primary.0"
                  variant="white"
                  radius="16px"
                  size="lg"
                >
                  <img
                    className={classes.plusIcon}
                    src={plusIcon}
                    alt="plus-icon"
                  />
                  {data.cta.addProperty}
                </Button>
              </MediaQuery>
            ) : (
              ''
            )}
          </Box>
          {userType === propertiesUserType.landlord ? (
            <MediaQuery query="(min-width: 500px)" styles={{ display: 'none' }}>
              <Button
                onClick={() => setViewAddManager(true)}
                color="primary.0"
                variant="white"
                radius="16px"
                size="lg"
                fullWidth={true}
              >
                {' '}
                <img
                  className={classes.plusIcon}
                  src={plusIcon}
                  alt="plus-icon"
                />
                {data.cta.addProperty}
              </Button>
            </MediaQuery>
          ) : (
            ''
          )}
        </Box>
        <Box className={classes.tableContainer}>
          <Table className={classes.table}>
            <thead className={classes.tableHead}>
              <tr>
                {data.tableHeading[userType.toLowerCase()].map((heading) => {
                  return <th className={classes.columnHeading}>{heading}</th>;
                })}
              </tr>
            </thead>
            <tbody>{rows}</tbody>
          </Table>
        </Box>
        {rows.length === 0 ? (
          <p className="no-record-found">{noRecordFound}</p>
        ) : (
          <Pagination
            size={'md'}
            defaultValue={activePage}
            onChange={pageChangeHandler}
            className={classes.pagination}
            siblings={1}
            total={totalPage}
          />
        )}
      </Box>
      <Modal
        opened={viewAddManager}
        onClose={() => setViewAddManager(false)}
        title={editManager ? 'Update Property Manager' : 'Add Property Manager'}
        size="lg"
        centered
        radius="md"
        overlayProps={{ blur: 3, opacity: 0.5 }}
      >
        <Stack spacing="md">
          {!editManager && (
            <Grid>
              <Col span={6}>
                <TextInput
                  label="Manager Name"
                  placeholder="Enter full name"
                  radius="lg"
                  className={classes.textInput}
                  value={mangerform.values.propertyManagerName}
                  onChange={(e) =>
                    mangerform.setFieldValue(
                      'propertyManagerName',
                      e.currentTarget.value
                    )
                  }
                />
              </Col>
              <Col span={6}>
                <TextInput
                  label="Manager Email"
                  placeholder="Enter email"
                  radius="lg"
                  className={classes.textInput}
                  value={mangerform.values.propertyManagerEmail}
                  onChange={(e) =>
                    mangerform.setFieldValue(
                      'propertyManagerEmail',
                      e.currentTarget.value
                    )
                  }
                />
              </Col>
            </Grid>
          )}
          <Grid>
            <Col span={6}>
              <Select
                label="Property"
                placeholder="Select property"
                radius="lg"
                className={classes.textInput}
                data={!editManager ? propertyOptions : updatepropertyOptions}
                value={mangerform.values.propertyId}
                onChange={(value) =>
                  mangerform.setFieldValue('propertyId', value)
                }
                withinPortal
              />
            </Col>
            <Col span={6}>
              <label className="mb-2 block font-medium text-sm text-gray-700">
                Access Permissions
              </label>
              <Group direction="column" spacing="xs">
                {[
                  { label: 'Service Request', value: 'service-request' },
                  { label: 'Read Only', value: 'Read Only' },
                  { label: 'Invoice', value: 'invoice' },
                  { label: 'Full Access', value: 'full-access' }
                ].map(({ label, value }) => (
                  <Checkbox
                    key={value}
                    label={label}
                    value={value}
                    checked={mangerform.values.propertyManagerAccess?.includes(
                      value
                    )}
                    onChange={(event) => {
                      const isChecked = event.currentTarget.checked;
                      const current =
                        mangerform.values.propertyManagerAccess || [];

                      let updatedAccess = [...current];

                      if (value === 'full-access') {
                        // Full Access overrides everything
                        updatedAccess = isChecked ? ['full-access'] : [];
                      } else {
                        // Remove 'full-access' if another checkbox is selected
                        updatedAccess = updatedAccess.filter(
                          (v) => v !== 'full-access'
                        );

                        if (value === 'invoice' && isChecked) {
                          // Uncheck 'Read Only' if 'Invoice' is selected
                          updatedAccess = updatedAccess.filter(
                            (v) => v !== 'Read Only'
                          );
                        }

                        if (value === 'Read Only' && isChecked) {
                          // Uncheck 'Invoice' if 'Read Only' is selected
                          updatedAccess = updatedAccess.filter(
                            (v) => v !== 'invoice'
                          );
                        }

                        if (isChecked) {
                          updatedAccess.push(value);
                        } else {
                          updatedAccess = updatedAccess.filter(
                            (v) => v !== value
                          );
                        }
                      }

                      mangerform.setFieldValue(
                        'propertyManagerAccess',
                        updatedAccess
                      );
                    }}
                  />
                ))}
              </Group>
            </Col>
          </Grid>

          <Divider my="sm" />

          <Group position="right">
            <Button
              variant="light"
              color="red"
              onClick={() => setViewAddManager(false)}
            >
              Cancel
            </Button>

            <Button
              onClick={handleAddManager}
              disabled={
                sending ||
                !mangerform.isValid() ||
                mangerform.getInputProps('propertyManagerAccess').value === null
              }
              styles={(theme) => ({
                root: {
                  backgroundColor: theme.colors.primary[0],
                  color: theme.white,
                  '&:hover': {
                    backgroundColor: theme.colors.primary[1]
                  }
                }
              })}
            >
              {editManager
                ? sending
                  ? 'Updating...'
                  : 'Update Manager'
                : sending
                ? 'Adding...'
                : 'Add Manager'}
            </Button>
          </Group>
        </Stack>
      </Modal>
    </>
  );
}

export default PropertyManagementList;
